import { Card, Flex, Text } from "@fluentui/react-northstar";
import React from "react";
import { InfiniteData } from "react-query";
import { RegularText } from "shared/components";
import pl from "shared/messages/pl";
import { EntityNoteHeader_PublicEntityType } from "shared/service/api/generated";
import { formatDate } from "utils/formattingUtils";
import { INoteList } from "view360Card/models/INoteList";
import { NoteList } from "../../../models";
import NotesListShowMoreButton from "../show-more-button/NotesListShowMoreButton";
import styles from "./notesList.module.scss";

export interface INotesListProps {
    isMobile: boolean;
    isError: boolean;
    isFetching: boolean;
    data: InfiniteData<INoteList | undefined> | undefined;
    hasNextPage: boolean | undefined;
    fetchNextPage: () => void;
    showFiltersPanel: boolean;
    selectedNoteId: number | undefined;
    onNoteSelected: (itemId: number, enitytyType: EntityNoteHeader_PublicEntityType, entityId: number) => void;
}

const NotesList: React.FC<INotesListProps> = ({
    isMobile,
    isError,
    isFetching,
    data,
    hasNextPage,
    fetchNextPage,
    showFiltersPanel,
    selectedNoteId,
    onNoteSelected,
}) => {

    const TextHeader = (text: string) => {
        return (
            <Flex hAlign="center" style={{ margin: "10px 0px" }}>
                <Text content={text} temporary />
            </Flex>
        );
    };

    if (isError) {
        return <span>{pl.view360Card.notes.errors.failedToFetchNotes}</span>;
    }

    let notes = data?.pages.flatMap((page) => page?.notes ?? []);


    if (isFetching) {
        return TextHeader(pl.view360Card.notes.notesList.loading);
    }

    if (!notes || notes.length === 0) {
        return TextHeader(pl.view360Card.notes.notesList.noNotesFound);
    }

    const notesList = new NoteList(notes);

    return (
            <Flex column className={isMobile ? styles.mobileList : styles.list} gap="gap.smaller" style={{ maxHeight: isMobile ? undefined : "100%" }}>
                {notesList.sections.map((section) => {
                    return (
                        <Flex column key={section.header}>
                            <RegularText content={section.header} weight="bold" />
                            <Flex column gap="gap.small">
                                {section.items.map((item, index) => {
                                    return (
                                        <Card
                                            fluid
                                            className={
                                                item.id === selectedNoteId ? styles.selectedItem : styles.card
                                            }
                                            key={index}
                                            onClick={() => {
                                                onNoteSelected(item.id ?? 0, item.entityType, item.entityId);
                                            }}
                                        >
                                            <Flex column>
                                                <Flex gap="gap.small" space="between" vAlign="center">
                                                    <RegularText content={formatDate(item.contactDate)} />
                                                    <RegularText content={item.createdBy.fullName} />
                                                </Flex>
                                                <RegularText content={item.type} />
                                            </Flex>
                                        </Card>
                                    );
                                })}
                            </Flex>
                        </Flex>
                    );
                })}
                {hasNextPage && <NotesListShowMoreButton onClick={fetchNextPage} isLoading={isFetching} />}
            </Flex>
    );
}

export default NotesList;